__turbopack_context__.v({
  "body": "ConnectionsReplaceModal-module__LrItzG__body",
  "bulletList": "ConnectionsReplaceModal-module__LrItzG__bulletList",
  "section": "ConnectionsReplaceModal-module__LrItzG__section",
});
